/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Uracil (U) is read as thymine (T), so an mRNA sequence translates to the same protein as its DNA.`)
};

const es_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El uracilo (U) se lee como timina (T), así que una secuencia de ARNm se traduce en la misma proteína que su ADN.`)
};

const de_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Uracil (U) wird als Thymin (T) gelesen, sodass eine mRNA-Sequenz zum gleichen Protein wie ihre DNA übersetzt wird.`)
};

const nl_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Uracil (U) wordt gelezen als thymine (T), zodat een mRNA-sequentie naar hetzelfde eiwit vertaalt als het bijbehorende DNA.`)
};

const fr_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. L'uracile (U) est lu comme la thymine (T), donc une séquence d'ARNm se traduit en la même protéine que son ADN.`)
};

const it_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. L'uracile (U) viene letto come timina (T), quindi una sequenza di mRNA si traduce nella stessa proteina del suo DNA.`)
};

const pt_br2_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A uracila (U) é lida como timina (T), então uma sequência de mRNA traduz-se na mesma proteína que seu DNA correspondente.`)
};

const pt_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O uracilo (U) é lido como timina (T), pelo que uma sequência de mRNA se traduz na mesma proteína que o seu ADN.`)
};

const ja_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。ウラシル (U) はチミン (T) として読み取られるため、mRNA配列はそのDNAと同じタンパク質に翻訳されます。`)
};

const zh_translate_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。尿嘧啶（U）按胸腺嘧啶（T）处理，因此 mRNA 序列翻译出的蛋白质与其 DNA 相同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_faq_a4", locale)
	if (locale === "en") return en_translate_faq_a4(inputs)
	if (locale === "es") return es_translate_faq_a4(inputs)
	if (locale === "de") return de_translate_faq_a4(inputs)
	if (locale === "nl") return nl_translate_faq_a4(inputs)
	if (locale === "fr") return fr_translate_faq_a4(inputs)
	if (locale === "it") return it_translate_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_translate_faq_a4(inputs)
	if (locale === "pt") return pt_translate_faq_a4(inputs)
	if (locale === "ja") return ja_translate_faq_a4(inputs)
	return zh_translate_faq_a4(inputs)
};